export default function TenorCalculation({ tenorCalculation }) {
  return (
    <div className="simulation mt-3">
      <div className="simulation-text">Simulasi Tenor dan Pinjaman</div>
      {tenorCalculation.map((item, index) => {
        return (
          <div key={index} className="d-flex align-items-center">
            <div className="col-6 px-0">{item.label}</div>
            <div className="col-6 px-0 simulation-text">{item.value}</div>
          </div>
        );
      })}
    </div>
  );
}
